import { render, staticRenderFns } from "./QualificationInfoCardNurse.vue?vue&type=template&id=63068f1e"
import script from "./QualificationInfoCardNurse.vue?vue&type=script&lang=js"
export * from "./QualificationInfoCardNurse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports